'use strict';

import { forEach, debounce } from 'lodash';

import containerManager from '../../01-helpers/filter-context/container-manager';
import { publish, subscribe } from '../../01-helpers/event-manager';
import { PILL_REMOVED } from '../../02-const/event-names';
import { FILTER_CHANGED, UPDATE_SEARCH } from '../../02-const/event-names';

import FilterSelectbox from '../../04-components/filtering/filter-select';


const moduleName = 'filter-select',
	selectors = {
		base: `.js-${moduleName}`,
		input: `.js-${moduleName}`,
	},
	attributeNames = {
		dataRefresh: 'data-refresh'
	};

export default class FilterSelect extends FilterSelectbox {

	constructor(baseElement) {
		super(baseElement);
		this._subscribeEvents();
		this._initSearchRadius();
	}

	_initSearchRadius() {
		const select = this.baseElement.querySelector('select');
		if (select && select.value) {
			this.filterContext.update(
				{ SearchRadiusInMeters: select.value },
				{ refresh: false }
			);
		}
	}

	/**
	 * configure the class
	 * @param {any} baseElement
	 */
	_configure(baseElement) {
		this.baseElement = baseElement;
		this.inputs = this.baseElement.querySelectorAll('select');
		this.filterContext = containerManager.getContainer();
	}

	_subscribeEvents() {
		subscribe(PILL_REMOVED, (event) => this._uncheckFilter(event));
	}

	_updateFilterContext(element) {
		const value = element.value;
		let query = this.filterContext.state.SearchRadius;

		query = value || '';

		return query;
	}

	_setValue(evt) {
		const query = event?.detail?.q,
			input = this.baseElement.querySelector(selectors.base);

		input.value = query || '';

		this._triggerFilterUpdate(input);
	}

	_triggerFilterUpdate(element) {
		const refresh = element.getAttribute(attributeNames.dataRefresh),
		sr = this._updateFilterContext(element);

		// Update the filterContext
		this.filterContext.update(
			{
				SearchRadiusInMeters: sr,
				NodeId: this.NodeId,
				Page: this.Page,
				Filters: this.filterContext.state.Filters
			},
			{ refresh: refresh === 'true' }
		);

		publish(FILTER_CHANGED);
	}

	/**
	 * on Submit handler 
	 * @param {any} evt
	 */
	_onSubmitEventHandler(evt) {
		evt.preventDefault();
		// get value and update filterContext
		const element = this.baseElement.querySelector('select');
		this._triggerFilterUpdate(element);

		return false;
	}

	_bindEvents() {

		this.baseElement.addEventListener('change', debounce((event) => {
			this._onSubmitEventHandler(event)
		}, 100), true
		);

		subscribe(UPDATE_SEARCH, (event) => this._setValue(event));
	}
}

/* ========================================================================== */

const initFilterSelect = () => {
	forEach(document.querySelectorAll(selectors.base), (selectionElement) => {
		new FilterSelect(selectionElement);
	});
};

initFilterSelect();